/**
 * 接收鼠标信息，处理信息绘制鼠标
 */
import { drawMouse, xcVariantDeserialize } from '@utils/xcase';
import pako from 'pako';
import { useEffect, useRef } from 'react';
import './VideoMouse.scss';

interface IVideoMouseProps {
  layerData: ArrayBuffer[];
  id: string;
  videoId: string;
}

const FRAG = 'frag';
// const jszip = new JSZip();

function concatUint8Arrays(arr1: any, arr2: any) {
  const newArray = new Uint8Array(arr1.length + arr2.length);
  newArray.set(arr1);
  newArray.set(arr2, arr1.length);
  return newArray;
}

const VideoMouse = (props: IVideoMouseProps) => {
  const preData = useRef<ArrayBuffer[]>();
  const zipDatalength = useRef<number>(0);
  // console.log('props:', props);
  useEffect(() => {
    if (!props.layerData) {
      return;
    }
    const { layerData } = props;
    handleLayerData(layerData);
  }, [props]);

  useEffect(() => {
    const video = document.getElementById(props.videoId) as HTMLVideoElement;
    const canvas = document.getElementById(`${props.id}-canvas`) as HTMLCanvasElement;
    if (!video || !canvas) return;
    // video.addEventListener('loadedmetadata', () => {
    //   console.log('==:', video.videoWidth);
    //   canvas.width = video.videoWidth;
    //   canvas.height = video.videoHeight;
    // });

    const width = video.offsetWidth;
    const height = video.offsetHeight;
    const canvasHeight = Math.round((width * 90) / 160);
    const canvasTop = `${(height - canvasHeight) / 2}px`;
    canvas.width = width;
    canvas.height = canvasHeight;
    canvas.style.top = canvasTop;

    return () => {};
  }, []);
  /**
   * @doc https://iwiki.woa.com/p/4010642610
   */
  const handleLayerData = async (layerData: any) => {
    if (layerData.length < 32 || new TextDecoder().decode(layerData.slice(0, 4)) !== FRAG) {
      console.log('收到的数据格式不正确');
      return;
    }

    /** 获取 fen_len 为什么不直接用  */
    const fenLengthData = layerData.slice(5, 7);
    const payloadLength = new DataView(fenLengthData.buffer).getUint16(0);
    // 解析count和index
    const countIndex = layerData[4];
    const count = (countIndex & 0xf0) >> 4; // 高4位为count
    const index = countIndex & 0x0f; // 低4位为index
    // console.log('layerData count:', count, 'index:', index);
    let payload = layerData.slice(7);
    if (payload.length > payloadLength) {
      payload = payload.slice(0, payloadLength);
    }
    if (count === 2 && index === 0) {
      preData.current = payload;
      zipDatalength.current = payloadLength;
      return;
    }
    // 如果是第二个鼠标流的包，则需要拼接数据
    if (count === 2 && index === 1 && preData.current) {
      // console.log('layerData count=2的payload1:', Array.from(payload));
      zipDatalength.current += payloadLength;
      // console.log('layerData secondLength:', payloadLength);
      payload = concatUint8Arrays(preData.current, payload);
      // console.log('layerData 合并后payload:', Array.from(payload));
    }
    // 不需要拼接的，丢弃preData
    if (count === 1) {
      preData.current = undefined;
      zipDatalength.current = payloadLength;
      // console.log('layerData 丢弃paylod');
      // return;
    }

    if (payload.length < 11) {
      console.log('数据合并后错误，payload长度不够');
      return;
    }
    // // 解析数据长度
    // const zipDataLength = new DataView(payload.buffer, 2, 2).getUint16(0);
    // console.log('layerData zipDataLength:', zipDatalength.current);
    const reakZipLength = zipDatalength.current - 10;
    let zipData = payload.slice(10);
    // console.log('layerData zipData截断前:', zipData);
    if (zipData.length > reakZipLength) {
      // 太长了需要截断
      zipData = zipData.slice(0, reakZipLength);
    }

    try {
      const result = pako.inflate(zipData);
      const mouseInfo = xcVariantDeserialize(result);
      drawMouse({ mouseInfo, id: `${props.id}-canvas` });
    } catch (err) {
      console.log('layerData paka errir:', err);
    }
  };

  return <canvas id={`${props.id}-canvas`} className="mouse-canvas" />;
};

export default VideoMouse;
